import {createGlobalStyle} from "styled-components";

export default createGlobalStyle`
  html {
    box-sizing: border-box;
    font-size: 16px;
  }

  *,
  *:before,
  *:after {
      box-sizing: inherit;
      font: inherit;
      padding: 0;
      margin: 0;
      border: 0;
      vertical-align: baseline;
      text-decoration: none;
  }

  *:focus {
    outline: none;
  }

  body {
    font-family: 'Roboto Flex', Arial, sans-serif;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    margin: 0;
  }

  a {
    color: #3253DC;
    text-decoration: none;
  }

  input {
    font-family: 'Roboto Flex', Arial, sans-serif;
  }
  //
  //input[type="text"] {
  //  padding-top: 5px;
  //}

@font-face {
  font-family: 'Roboto Flex';
  font-style: normal;
  font-weight: 100 900;
  src: url(/fonts/RobotoFlex-VariableFont.ttf) format('truetype');
}
`;